<template>
  <!-- begin panel -->
  <b-card no-body>
    <b-tabs
      justified
      v-model="tabIndex"
      nav-class="nav-tabs-inverse"
      nav-wrapper-class="nav-tabs-inverse"
    >
      <!-- begin tab -->
      <b-tab @click="navigateTo('space')" v-if="contentIs4S">
        <template slot="title">
          <span class="d-sm-none">Space tasks</span>
          <span class="d-sm-block d-none">Space tasks</span>
        </template>
      </b-tab>
      <!-- end tab -->
      <!-- begin tab -->
      <b-tab @click="navigateTo('stuff')" v-if="contentIs4S">
        <template slot="title">
          <span class="d-sm-none">Stuff tasks</span>
          <span class="d-sm-block d-none">Stuff tasks</span>
        </template>
      </b-tab>
      <!-- end tab -->
      <!-- begin tab -->
      <b-tab @click="navigateTo('staff')" v-if="contentIs4S">
        <template slot="title">
          <span class="d-sm-none">Staff tasks</span>
          <span class="d-sm-block d-none">Staff tasks</span>
        </template>
      </b-tab>
      <!-- end tab -->
      <!-- begin tab -->
      <b-tab @click="navigateTo('service')" v-if="contentIs4S">
        <template slot="title">
          <span class="d-sm-none">Service tasks</span>
          <span class="d-sm-block d-none">Service tasks</span>
        </template>
      </b-tab>
      <!-- end tab -->
      <b-tab @click="navigateTo('storyboard')" v-if="!contentIs4S">
        <template slot="title">
          <span class="d-sm-none">Storyboard tasks</span>
          <span class="d-sm-block d-none">Storyboard tasks</span>
        </template>
      </b-tab>
      <!-- end tab -->
      <b-tab @click="navigateTo('stage')" v-if="!contentIs4S">
        <template slot="title">
          <span class="d-sm-none">Stage tasks</span>
          <span class="d-sm-block d-none">Stage tasks</span>
        </template>
      </b-tab>
      <!-- end tab -->
      <b-tab @click="navigateTo('step')" v-if="!contentIs4S">
        <template slot="title">
          <span class="d-sm-none">Step tasks</span>
          <span class="d-sm-block d-none">Step tasks</span>
        </template>
      </b-tab>
      <!-- end tab -->

      <div class="p-20">
        <div class="row" v-if="contentIs4S">
          <div class="col-xl-12 m-b-15">
            <b-form-radio-group
              v-model="categoryLevel"
              buttons
              button-variant="outline-secondary"
            >
              <b-form-radio value="category">{{
                buttonCategoryLabel
              }}</b-form-radio>
              <b-form-radio value="subcategory">{{
                buttonSubcategoryLabel
              }}</b-form-radio>
              <b-form-radio value="item">Items</b-form-radio>
            </b-form-radio-group>
          </div>
        </div>
        <task-item-table
          :filteredItems="getLevelItems()"
          :items="items"
          :categories="categories"
          :steps="steps"
          :scriptItems="scriptItems"
          :activeEvent="activeEvent"
          :contentIs4S="contentIs4S"
          :categoryLevel="categoryLevel"
          :filterCategorySteps="filterCategorySteps"
          :filterCategoryScriptItems="filterCategoryScriptItems"
        />
      </div>
    </b-tabs>
  </b-card>
</template>

<script>
import TaskItemTable from '../task/TaskItemTable.vue'

export default {
  name: 'TaskContent',
  props: [
    'categories',
    'items',
    'storyboards',
    'stages',
    'steps',
    'scriptItems',
    'activeEvent'
  ],
  components: {
    TaskItemTable
  },
  data() {
    return {
      tabIndex: 0,
      categoryLevel: 'category',
      buttonCategoryLabel: 'Categories',
      buttonSubcategoryLabel: 'Subcategories'
    }
  },
  computed: {
    contentIs4S() {
      let level = this.$route.params.level
      switch (level) {
        case 'step':
          return false
        case 'stage':
          return false
        case 'storyboard':
          return false
        case 'service':
          return true
        case 'space':
          return true
        case 'staff':
          return true
        case 'stuff':
          return true
        default:
          return false
      }
    }
  },
  methods: {
    navigateTo(typeParam) {
      if (this.$route.params.level != typeParam) {
        this.$router.push({ params: { level: typeParam } })
      }
    },
    getImage(image) {
      if (image == null) {
        return require('../../assets/images/login-bg.png')
      } else {
        return process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd
      }
    },
    filterEventStoryboards(event) {
      return this.storyboards.filter(function (sb) {
        return sb.event == event
      })
    },
    filterEventStages(event, sbFilterState = 'all') {
      var storyboards = this.filterEventStoryboards(event)
      var fStages = []
      storyboards.forEach((sb) => {
        var stages = this.stages.filter(function (stage) {
          return stage.storyboard == sb.id
        })
        stages.forEach((stage) => {
          if (!fStages.includes(stage) && stage.steps.length) {
            if (sbFilterState == 'all') {
              fStages.push(stage)
            } else {
              if (stage.storyboard == sbFilterState) {
                fStages.push(stage)
              }
            }
          }
        })
      })
      return fStages
    },
    filterEventSteps(event) {
      var storyboards = this.filterEventStoryboards(event)
      var fStepIds = []
      storyboards.forEach((sb) => {
        var stages = this.stages.filter(function (stage) {
          return stage.storyboard == sb.id
        })
        stages.forEach((stage) => {
          stage.steps.forEach((step) => {
            fStepIds.push(step.id)
          })
        })
      })
      return this.steps.filter((step) => {
        return fStepIds.includes(step.id)
      })
    },
    filterEventScriptItems(event) {
      return this.scriptItems.filter(function (sItem) {
        return sItem.item.event == event
      })
    },
    filterStepScriptItems(step, type = 0) {
      return this.scriptItems.filter(function (sItem) {
        if (type) {
          return (
            sItem.confirmed &&
            sItem.step.id == step.id &&
            sItem.item.type == type
          )
        } else {
          return sItem.confirmed && sItem.step.id == step.id
        }
      })
    },
    filterStageScriptItems(stage) {
      let scriptItemsInStage = []
      if (stage.steps.length) {
        stage.steps.forEach((step) => {
          this.scriptItems.forEach((sItem) => {
            if (sItem.confirmed && sItem.step.id == step.id) {
              scriptItemsInStage.push(sItem)
            }
          })
        })
        return scriptItemsInStage
      } else {
        return scriptItemsInStage
      }
    },
    filterStoryboardScriptItems(storyboard) {
      let scriptItemsInStoryboard = []
      if (storyboard.stages.length) {
        storyboard.stages.forEach((stage) => {
          var fStages = this.stages.filter(function (fStage) {
            return stage.id == fStage.id
          })
          fStages.forEach((fStage) => {
            fStage.steps.forEach((step) => {
              var items = this.filterStepScriptItems(step)
              items.forEach((item) => {
                scriptItemsInStoryboard.push(item)
              })
            })
          })
        })
        return scriptItemsInStoryboard
      } else {
        return scriptItemsInStoryboard
      }
    },
    filterCategoryScriptItems(item) {
      let scriptItemsInCategory = []
      if (!item.parent) {
        var subCategories = []
        item.children.forEach((subCategory) => {
          subCategories.push(subCategory.id)
        })
        this.scriptItems.forEach((sItem) => {
          if (sItem.confirmed && subCategories.includes(sItem.item.category)) {
            scriptItemsInCategory.push(sItem)
          }
        })
        return scriptItemsInCategory
      } else {
        this.scriptItems.forEach((sItem) => {
          if (sItem.confirmed && sItem.item.category == item.id) {
            scriptItemsInCategory.push(sItem)
          }
        })
        return scriptItemsInCategory
      }
    },
    filterCategorySteps(item) {
      let stepsInCategory = []
      if (!item.parent) {
        var subCategories = []
        item.children.forEach((subCategory) => {
          subCategories.push(subCategory.id)
        })
        this.scriptItems.forEach((sItem) => {
          if (
            sItem.confirmed &&
            subCategories.includes(sItem.item.category) &&
            !stepsInCategory.includes(sItem.step)
          ) {
            stepsInCategory.push(sItem.step)
          }
        })
        return stepsInCategory
      } else {
        this.scriptItems.forEach((sItem) => {
          if (
            sItem.confirmed &&
            sItem.item.category == item.id &&
            !stepsInCategory.includes(sItem.step)
          ) {
            stepsInCategory.push(sItem.step)
          }
        })
        return stepsInCategory
      }
    },
    getStoryboardSteps(storyboard) {
      var storyboardStageIds = []
      storyboard.stages.forEach((stage) => {
        storyboardStageIds.push(stage.id)
      })
      return this.steps.filter(function (step) {
        return storyboardStageIds.includes(step.stage)
      })
    },
    getStoryboardStages(storyboard) {
      return this.stages.filter(function (stage) {
        return stage.storyboard == storyboard.id
      })
    },
    getStage(stageId) {
      var fullStage
      this.stages.forEach(function (stage) {
        if (stage.id == stageId) {
          fullStage = stage
        }
      })
      return fullStage
    },
    getStoryboard(stageId) {
      var storyboards = this.filterEventStoryboards(this.activeEvent.id)
      var stage = this.getStage(stageId)
      if (!stage) {
        return
      }
      var storyboard = storyboards.find(function (sb) {
        return sb.id == stage.storyboard
      })
      return storyboard
    },
    getTypeName(typeId) {
      switch (typeId) {
        case 1:
          return 'service'
        case 2:
          return 'space'
        case 3:
          return 'staff'
        case 4:
          return 'stuff'
        default:
          return 'service'
      }
    },
    goToScript(step, typeName) {
      this.$router.push(`/script/${typeName}/${step.id}`)
    },
    getLevelItems() {
      let level = this.$route.params.level
      let eventId = this.activeEvent.id
      switch (level) {
        case 'step':
          this.$nextTick(() => {
            this.tabIndex = 2
          });
          return this.filterEventSteps(eventId)
        case 'stage':
          this.$nextTick(() => {
            this.tabIndex = 1
          });
          return this.filterEventStages(eventId)
        case 'storyboard':
          this.$nextTick(() => {
            this.tabIndex = 0
          });
          return this.filterEventStoryboards(eventId)
        case 'space':
          this.$nextTick(() => {
            this.tabIndex = 0
          });
          if (this.categoryLevel == 'item') {
            return this.items
          } else {
            return this.categories
          }
        case 'service':
          this.$nextTick(() => {
            this.tabIndex = 3
          });
          if (this.categoryLevel == 'item') {
            return this.items
          } else {
            return this.categories
          }
        case 'staff':
          this.$nextTick(() => {
            this.tabIndex = 2
          });
          if (this.categoryLevel == 'item') {
            return this.items
          } else {
            return this.categories
          }
        case 'stuff':
          this.$nextTick(() => {
            this.tabIndex = 1
          });
          if (this.categoryLevel == 'item') {
            return this.items
          } else {
            return this.categories
          }
        default:
          break
      }
    },
    updateLabels() {
      let level = this.$route.params.level
      switch (level) {
        case 'service':
          this.buttonSubcategoryLabel = 'Areas'
          this.buttonCategoryLabel = 'Categories'
          break
        case 'space':
          this.buttonSubcategoryLabel = 'Areas'
          this.buttonCategoryLabel = 'Venues'
          break
        case 'staff':
          this.buttonSubcategoryLabel = 'Teams'
          this.buttonCategoryLabel = 'Groups'
          break
        case 'stuff':
          this.buttonSubcategoryLabel = 'Subcategories'
          this.buttonCategoryLabel = 'Categories'
          break
        default:
          break
      }
    }
  },
  watch: {
    $route() {
      this.getLevelItems()
      this.updateLabels()
    }
  }
}
</script>
